import {Mapper} from '@s-ui/domain'

export class SeoHomeMetaInformationMapper extends Mapper {
  constructor({config, seoDataValueObjectFactory, seoDataMapper, structuredDataValueObjectFactory}) {
    super()

    this._config = config
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
    this._seoDataMapper = seoDataMapper
    this._structuredDataValueObjectFactory = structuredDataValueObjectFactory
  }

  _buildCanonical = () => {
    const protocol = this._config.get('URL_PROTOCOL')
    const host = this._config.get('HOST_DOMAIN')
    const {HOME_PATH_PATTERN} = this._config.get('page')

    return `${protocol}${host}${HOME_PATH_PATTERN}`
  }

  async map({culture}) {
    const {home: homeConfig} = this._config.get('seo')
    const {organization} = this._config.get('schema')
    const {TITLE, META_DESCRIPTION, META_ROBOTS} = homeConfig[culture]

    const canonical = this._buildCanonical()
    const organizationStructuredData = this._structuredDataValueObjectFactory(organization)

    const {links, metas, scripts, title} = this._seoDataMapper
      .title(TITLE)
      .description(META_DESCRIPTION)
      .robots(META_ROBOTS)
      .canonical(canonical)
      .addSchemaData(organizationStructuredData)
      .setOpenGraphData({
        title: TITLE,
        description: META_DESCRIPTION,
        url: canonical
      })
      .setTwitterCardsData()
      .map()

    return this._seoDataValueObjectFactory({
      head: {
        link: links,
        meta: metas,
        scripts,
        title
      }
    })
  }
}
